export default "__VITE_ASSET__3d31528b__$_?react__"